export default __webpack_public_path__ + "static/media/img_17.142461eb.JPG";